import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class DamagedService {
  static LOAD_TYPES = "/api/load_types/select";

  static getAllDamaged = async (params: any) => {
    try {
      return await Http.get(API_URLs.settings.damaged, params);
    } catch (error) {
      return error;
    }
  };
  static getOneDamaged = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.settings.damaged, id);
    } catch (error) {
      return error;
    }
  };
  static createDamaged = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.damaged, data);
    } catch (error) {
      return error;
    }
  };

  static updateDamaged = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.damaged, data);
    } catch (error) {
      return error;
    }
  };

  static deleteDamaged = async (id: number) => {
    try {
      return await Http.delete(API_URLs.settings.damaged, id);
    } catch (error) {
      return error;
    }
  };

  static getAllLoadTypes = async (params?: any) => {
    try {
      return await Http.get(this.LOAD_TYPES, params);
    } catch (error) {
      return error;
    }
  };
}
